/**
 * Session-Token-Storage in localStorage (Phase 3.5 §2 Minimal-Stub, voll in §3).
 *
 * Phase 4: wechselt zu HttpOnly-Cookie (mit Custom-Domain). localStorage hat
 * XSS-Risiko, ist aber für Phase 3 mit workers.dev cross-domain die einzige
 * praktikable Option (Cookies können nicht sicher zwischen pages.dev und
 * workers.dev geteilt werden ohne SameSite=None+Secure-Magic).
 */

const TOKEN_KEY = "ct_session_token";
const TOKEN_EXP_KEY = "ct_session_exp";

export type StoredToken = {
  token: string;
  exp: number; // Unix-Sekunden (gleich wie JWT-exp-Claim)
};

export function setToken(token: string, exp: number): void {
  try {
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(TOKEN_EXP_KEY, String(exp));
  } catch (err) {
    console.warn(`[token] setToken failed: ${(err as Error).message}`);
  }
}

/**
 * Returnt das aktive Token wenn vorhanden + nicht abgelaufen.
 * Bei Expiry wird der Storage automatisch aufgeräumt.
 */
export function getToken(): string | null {
  try {
    const token = localStorage.getItem(TOKEN_KEY);
    const expRaw = localStorage.getItem(TOKEN_EXP_KEY);
    if (!token || !expRaw) return null;

    const exp = Number.parseInt(expRaw, 10);
    if (!Number.isFinite(exp) || exp * 1000 < Date.now()) {
      clearToken();
      return null;
    }
    return token;
  } catch (err) {
    console.warn(`[token] getToken failed: ${(err as Error).message}`);
    return null;
  }
}

export function clearToken(): void {
  try {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(TOKEN_EXP_KEY);
  } catch (err) {
    console.warn(`[token] clearToken failed: ${(err as Error).message}`);
  }
}

/** Helper für UI-Komponenten: Sekunden bis Token-Expiry, 0 wenn abgelaufen/leer. */
export function getTokenTtlSec(): number {
  try {
    const expRaw = localStorage.getItem(TOKEN_EXP_KEY);
    if (!expRaw) return 0;
    const exp = Number.parseInt(expRaw, 10);
    const remaining = exp - Math.floor(Date.now() / 1000);
    return Math.max(0, remaining);
  } catch {
    return 0;
  }
}
